module.exports = __webpack_public_path__ + "media/images/common/privacy-mark-081d4fa5cf127a6d4b1ae9bf610e4004.png";